import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { StatusPageService } from '../services/status-page.service';
import { map } from 'rxjs/operators';

export const maintenanceGuard: CanActivateFn = () => {
    const statusPage: StatusPageService = inject(StatusPageService);
    return statusPage.checkForDowntime().pipe(map((downTime) => !downTime));
};
